// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tGBVv","colBig":"styles_colBig__3F4Dg","colSmall":"styles_colSmall__2rPRn","shopifyNameWrapper":"styles_shopifyNameWrapper__2RlXe"};